<template>
  <div class="datePicker">
    <span class="material-input-bar" />
    <label class="material-label">
      <slot />
    </label>
    <br v-if="$slots['default']" />
    <el-date-picker
      v-if="!disabled"
      v-model="currentValue"
      :type="type"
      :format="format"
      :name="name"
      :placeholder="fillPlaceHolder"
      :readonly="readonly"
      :required="required"
      @input="handleModelInput"
    />
    <span v-if="disabled" class="datePicker-disabled">{{ valueString }}</span>
  </div>
</template>

<script>
import { getDayJSFormatFromElementFormat } from '@/utils';
const dayjs = require('dayjs');
export default {
  props: {
    disabled: Boolean,
    format: {
      default: 'dd-MM-yyyy HH:mm',
      type: String
    },
    name: String,
    placeholder: {
      default: '',
      type: String
    },
    readonly: Boolean,
    required: {
      default: true,
      type: Boolean
    },
    value: [String, Number],
    type: {
      type: String,
      default: 'datetime'
    }
  },
  data() {
    return {
      currentValue: this.value
    };
  },
  computed: {
    fillPlaceHolder() {
      return this.currentValue ? '' : this.placeholder;
    },
    valueString() {
      const dt = new Date(this.currentValue).toString();
      const format = getDayJSFormatFromElementFormat(this.format);
      return this.currentValue && dayjs(dt).format(format);
    }
  },
  watch: {
    value(newValue) {
      this.currentValue = newValue;
    }
  },
  mounted() {
    /*
     * On default, element creates an 'input' element for el-date-picker
     * and gives it the attribute 'autocomplete=off'. This is however ignored
     * by Chrome, allowing its Autofill to fill the input with jibberish.
     * The workaround is to give the attribute autocomplete any random
     * string other than the accepted values 'on' or 'off'.
     *
     * See: https://gist.github.com/niksumeiko/360164708c3b326bd1c8
     */
    this.$el.querySelectorAll('input').forEach(input => {
      input.setAttribute('autocomplete', 'ignore');
    });
  },
  methods: {
    handleModelInput(event) {
      const value = event && Date.parse(event);
      this.$emit('input', value);
      this.$emit('change', value);
    }
  }
};
</script>

<style scoped>
.datePicker-disabled {
  margin-top: 5px;
  display: block;
}
</style>

<style>
.material-label {
  color: #9e9e9e;
}
</style>
